// extracted by mini-css-extract-plugin
export default {"mainHeader":"Navigation_mainHeader__3Rw3u","navLinks":"Navigation_navLinks__txaGq","navUl":"Navigation_navUl__FB-i8"};